module.exports = __webpack_public_path__ + "static/media/Safety.c84da089.jpg";